// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bho_a bho_x bho_j bho_u bho_bc bho_ql bho_vv"};